module.exports = KsysAppTemplateV2dot41dot5;